export const API_KEY='AIzaSyBVWH-zdpu4BkVhhOpjPmVvxTE0bWYZkXk';
export default API_KEY;